import {Link} from "react-router-dom";
import {HashLink} from "react-router-hash-link";

function SidebarSubItem({ label, url }) {
    return (
        <HashLink to={url}>
            <div className="py-3 border-b border-white/10 text-[14px] cursor-pointer">
                {label}
            </div>
        </HashLink>
    );
}

export default SidebarSubItem;
